import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Checkbox,
  Tooltip,
  Button,
  makeStyles,
  FormHelperText,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import TextEditor from "./TextEditor.js";
import AlertDialog from "../../../components/AlertDialog.js";
import infoImg from "../../../assets/icons/info.png";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import DoneIcon from "@mui/icons-material/Done";

import FormControlLabel from "@mui/material/FormControlLabel";

const findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;
const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#0D47A1",
    },
  },
  subDialog: {
    "& .MuiDialogContent-root": {
      padding: 0,
    },
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: "1100px",
      height: "600px",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  textFieldOnFormStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  mutiOptTextStyle: {
    marginBottom: 5,
    marginTop: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      fontSize: 16,
    },
  },
  mutiOptFieldsStyle: {
    marginTop: 5,
    marginLeft: 5,
    borderRadius: 10,
    paddingLeft: 5,
    width: 305,
    backgroundColor: "#f0fafe",
    "& .MuiInputBase-root": {
      // The text
      fontSize: 14,
      // color: "#a3a3a3",
    },
    "& .MuiInputBase-root:before": {
      borderBottom: "none",
    },
    "& .MuiInputBase-root:after": {
      borderBottom: "none",
    },
    "& .MuiInputBase-root:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInputBase-root.Mui-focused": {
      color: "#000",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "blue",
      // backgroundColor: "rgb(250, 241, 232)",
    },
  },
  mutiOptContainerStyle: {
    padding: 0,
  },
  mutiOptCardStyle: {
    maxHeight: 200,
    overflow: "auto",
  },

  switch: {
    "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
      backgroundColor: "#0D47A1",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#0D47A1",
    },
  },

  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
}));

export default function AddCheckboxToFormDialog({ closeDialog, handleDone }) {
  const classes = useStyles();
  const [singleOpt, setSingleOpt] = useState(false);
  const [multipleOpt, setMultipleOpt] = useState(false);
  const [multiOptTxt, setMultiOptTxt] = useState("");
  const [mutiOptFields, setMutiOptFields] = useState([]);
  const [currMutiOptFields, setCurrMutiOptFields] = useState([]);
  const [currEditOptTxt, setCurrEditOptTxt] = useState("");

  const addMutiTextVal = useRef(null);
  const editorRef = useRef(null);

  const [open, setOpen] = useState(true);
  const [infoIcon, setInfoIcon] = useState(false);
  const [manAnswer, setManAnswer] = useState(false);
  const [queText, setQueText] = useState(false);
  const [queRaw, setQueRaw] = useState(false);
  const [capText, setCapText] = useState(false);
  const [capRaw, setCapRaw] = useState(false);
  const [infoTxt, setInfoTxt] = useState("");
  const [alertMsg, setAlertMsg] = useState([]);

  const [checkError, setCheckError] = useState(false);

  useEffect(() => {
    if (multipleOpt === true) addMutiTextVal.current.focus();
  }, [multipleOpt]);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleChangeTextEditor = (txt, type) => {
    let contentHTML = draftToHtml(txt);
    contentHTML = contentHTML.replace(/<p>/, "");
    
    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    const convertedTxt = ReactHtmlParser(contentHTML);

    if (type === "question") {
      setQueText(convertedTxt);
      setQueRaw(txt);
    }
    if (type === "caption") {
      setCapText(convertedTxt);
      setCapRaw(txt);
    }
  };

  const handleChangeOption = event => {
    let optVal = event.target.value;
    if (optVal === "single") {
      setSingleOpt(true);
      setMultipleOpt(false);
      setCurrMutiOptFields([...mutiOptFields]);
      setMutiOptFields([]);
    } else if (optVal === "multiple") {
      setSingleOpt(false);
      setMultipleOpt(true);
      setMutiOptFields([...currMutiOptFields]);
    } else {
      setSingleOpt(false);
      setMultipleOpt(false);
    }
  };

  const addMutiOptTextField = () => {
    if (multiOptTxt.trim() === "") return;

    let mutiOptFieldsText = findAnd.returnFound(mutiOptFields, {
      textVal: multiOptTxt.trim(),
    });
    if (mutiOptFieldsText !== undefined) {
      setAlertMsg({
        title: "Option Label Validation",
        msg: "Option label already exists. Please input a different label.",
      });
      return;
    }

    setMutiOptFields([
      ...mutiOptFields,
      { textVal: multiOptTxt.trim(), editMode: false },
    ]);
    setMultiOptTxt("");
    addMutiTextVal.current.focus();
  };

  const handleMutiOptTextChange = (index, e) => {
    let newTextValues = [...mutiOptFields];
    newTextValues[index]["textVal"] = e.target.value;
    setMutiOptFields(newTextValues);
  };

  const deleteMutiOptText = (index, e) => {
    let mutiOptFieldsText = findAnd.returnFound(mutiOptFields, {
      editMode: true,
    });
    if (mutiOptFieldsText !== undefined) return;

    let newTextValues = [...mutiOptFields];
    newTextValues.splice(index["index"], 1);
    setMutiOptFields(newTextValues);
    addMutiTextVal.current.focus();
  };

  const editMutiOptText = (index, e) => {
    if (currEditOptTxt !== "") return;
    let i = index["index"];
    let newEditMode = [...mutiOptFields];
    newEditMode[i]["editMode"] = true;
    setMutiOptFields(newEditMode);
    setCurrEditOptTxt(newEditMode[i]["textVal"]);
  };

  const saveMutiOptText = (index, e) => {
    let i = index["index"];
    let newEditMode = [...mutiOptFields];
    let newVal = newEditMode[i]["textVal"].trim();

    if (newVal === "") return;

    let mutiOptFieldsText = findAnd.returnFound(mutiOptFields, {
      textVal: newVal,
      editMode: false,
    });
    if (mutiOptFieldsText !== undefined) {
      setAlertMsg({
        title: "Option Label Validation",
        msg: "Option label already exists. Please input a different label.",
      });
      return;
    }

    newEditMode[i]["editMode"] = false;
    setMutiOptFields(newEditMode);
    setCurrEditOptTxt("");
    addMutiTextVal.current.focus();
  };

  const cancelMutiOptText = (index, e) => {
    let i = index["index"];
    let newEditMode = [...mutiOptFields];
    newEditMode[i]["editMode"] = false;
    newEditMode[i]["textVal"] = currEditOptTxt;
    setMutiOptFields(newEditMode);
    setCurrEditOptTxt("");
    addMutiTextVal.current.focus();
  };

  const MutiAddButton = () => (
    <>
      <Tooltip
        style={{
          height: "25px",
        }}
        title="Add"
      >
        <IconButton>
          <AddIcon onClick={addMutiOptTextField} />
        </IconButton>
      </Tooltip>
    </>
  );

  const MutiEditDelButtons = index => {
    return (
      <>
        <Tooltip title="Edit">
          <IconButton>
            <EditIcon onClick={e => editMutiOptText(index, e)} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon onClick={e => deleteMutiOptText(index, e)} />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const MutiEditModeButtons = index => {
    return (
      <>
        <Tooltip title="Save">
          <IconButton>
            <DoneIcon onClick={e => saveMutiOptText(index, e)} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cancel">
          <IconButton>
            <CloseIcon onClick={e => cancelMutiOptText(index, e)} />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const mutiOptTextKeyPress = e => {
    if (e.keyCode == 13) {
      addMutiOptTextField();
    }
  };

  const mutiOptFieldTextKeyPress = (i, e) => {
    if (e.keyCode == 13) {
      let newVal = e.target.value.trim();

      if (newVal === "") return;

      let mutiOptFieldsText = findAnd.returnFound(mutiOptFields, {
        textVal: newVal,
        editMode: false,
      });
      if (mutiOptFieldsText !== undefined) {
        setAlertMsg({
          title: "Option Label Validation",
          msg: "Option label already exists. Please input a different label.",
        });
        return;
      }

      let newEditMode = [...mutiOptFields];
      newEditMode[i]["editMode"] = false;
      setMutiOptFields(newEditMode);
      setCurrEditOptTxt("");
      addMutiTextVal.current.focus();
    }
  };

  const validateFields = () => {
    setCheckError(true);
    if (queRaw.blocks[0].text.trim() === "") {
      editorRef.current.focus();
      return false;
    }
    if (infoIcon && infoTxt.trim() === "") {
      return false;
    }
    return true;
  };

  // console.log("queRaw: ", queRaw);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="xl"
      //  onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.subDialog}
    >
      <DialogTitle sx={{ p: 0 }} id="alert-dialog-title">
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Grid container>
            <Grid
              item
              lg={4}
              xl={4}
              md={4}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: 15,
              }}
            >
              <Box style={{ width: 100 }}>
                <IconButton
                  aria-label="close"
                  sx={{
                    position: "absolute",
                    left: 8,
                    top: 8,
                    align: "right",
                    color: theme => theme.palette.grey[500],
                  }}
                  onClick={e => {
                    if (queRaw.blocks[0].text || capRaw.blocks[0].text || infoTxt)
                      setAlertMsg({
                        title: "Exit",
                        type: "saveConfirmation",
                        msg: "Are you sure you want to exit without saving your work?",
                      });
                    else handleClose();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box pt={2} style={{ width: 350 }}>
                <Typography
                  variant="h1"
                  style={{
                    fontSize: 20,
                    display: "flex",
                    //    flexDirection: "end",
                    alignItems: "center",
                  }}
                >
                  Object: Checkbox
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={8} xl={8} md={8} style={{ backgroundColor: "#E3F2FD" }}></Grid>
          </Grid>
        </Box>
      </DialogTitle>
      <DialogContent
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Grid container>
          <Grid item lg={4} xl={4} md={4}>
            <Card style={{ maxHeight: "550px", overflowY: "scroll" }}>
              <Box mb={1} mt={5}>
                <Divider />
                <Box mt={2} ml={2}>
                  <Typography variant="h3">Question*</Typography>
                </Box>
                <Box mt={2} ml={2} mb={2} mr={2}>
                  <TextEditor
                    type="question"
                    handleChangeText={(txt, type) => handleChangeTextEditor(txt, type)}
                    editorRef={editorRef}
                  />
                  {checkError && queRaw && queRaw.blocks[0].text.trim() === "" && (
                    <FormHelperText className={classes.errorStyle} error>
                      Question field cannot be blank.
                    </FormHelperText>
                  )}
                </Box>
                <Divider />
                <Box mt={2} ml={2}>
                  <Typography variant="h3">Caption</Typography>
                </Box>
                <Box mt={2} ml={2} mb={2} mr={2}>
                  <TextEditor
                    type="caption"
                    handleChangeText={(txt, type) => handleChangeTextEditor(txt, type)}
                  />
                </Box>
                <Divider />
                <Box mt={2} ml={2}>
                  <Typography variant="h3">Option</Typography>
                </Box>
                <Box mt={2} mb={2} ml={2} mr={2}>
                  <FormControl fullWidth>
                    <InputLabel>Select</InputLabel>
                    <Select
                      label="Select"
                      // value={optval}
                      margin="normal"
                      onChange={handleChangeOption}
                    >
                      <MenuItem value={"single"}>Single checkbox</MenuItem>
                      <MenuItem value={"multiple"}>Multiple checkbox</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {multipleOpt && (
                  <Box ml={2} mb={2} mr={2}>
                    <TextField
                      variant="outlined"
                      placeholder="Enter Option Label"
                      value={multiOptTxt}
                      onChange={e => setMultiOptTxt(e.target.value)}
                      onKeyDown={mutiOptTextKeyPress}
                      className={classes.mutiOptTextStyle}
                      inputRef={addMutiTextVal}
                      fullWidth
                      // multiline
                      InputProps={{ endAdornment: <MutiAddButton /> }}
                    />
                    <Card variant="outlined" className={classes.mutiOptCardStyle}>
                      <CardContent className={classes.mutiOptContainerStyle}>
                        {mutiOptFields.map((element, index) => (
                          <TextField
                            variant="standard"
                            name="textVal"
                            multiline
                            value={element.textVal}
                            disabled={!element.editMode}
                            onChange={e => handleMutiOptTextChange(index, e)}
                            onKeyDown={e => mutiOptFieldTextKeyPress(index, e)}
                            className={classes.mutiOptFieldsStyle}
                            InputProps={
                              element.editMode
                                ? { endAdornment: <MutiEditModeButtons index={index} /> }
                                : { endAdornment: <MutiEditDelButtons index={index} /> }
                            }
                            inputRef={input => input && input.focus()}
                          />
                        ))}
                      </CardContent>
                    </Card>
                  </Box>
                )}
                <Divider />
                <Box
                  mt={2}
                  ml={2}
                  mr={1}
                  mb={2}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h3">Answer is Mandatory</Typography>
                  <Switch
                    checked={manAnswer}
                    onChange={() => setManAnswer(!manAnswer)}
                    className={classes.switch}
                  />
                </Box>
                <Divider />
                <Box
                  mt={2}
                  ml={2}
                  mr={1}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h3">Enable Information Icon</Typography>
                  <Switch
                    checked={infoIcon}
                    onChange={() => {
                      setInfoIcon(!infoIcon);
                      infoIcon && setInfoTxt("");
                    }}
                    className={classes.switch}
                  />
                </Box>
                <Box ml={2} mb={2} mr={2}>
                  <TextField
                    id="outlined-multiline-static"
                    variant="outlined"
                    placeholder="Type tooltip label..."
                    value={infoTxt}
                    disabled={!infoIcon}
                    onChange={e => setInfoTxt(e.target.value)}
                    className={classes.textFieldStyle}
                    fullWidth
                    inputRef={input => input && !infoTxt && input.focus()}
                    helperText={
                      checkError &&
                      infoIcon &&
                      infoTxt.trim() === "" &&
                      "This field cannot be blank."
                    }
                    error={checkError && infoIcon && infoTxt.trim() === ""}
                  />
                </Box>
                <Box
                  mt={5}
                  ml={2}
                  //  mb={3}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    // background: "white",
                    // position: "sticky",
                    // top: 20,
                    // bottom: 20,
                    // paddingTop: "40px",
                    // paddingBottom: "40px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonStyle}
                    style={{ marginRight: 2 }}
                    onClick={() => {
                      if (!validateFields()) return;
                      if(multipleOpt && mutiOptFields.length < 2){
                        setAlertMsg({
                          title: "Alert",
                          msg: "Multiple CheckBox needs at least two options.",
                        });
                        return
                      };
                      if (queRaw.blocks[0].text || capRaw.blocks[0].text || infoTxt)
                        handleDone(
                          "Checkbox",
                          "done",
                          infoIcon,
                          manAnswer,
                          queText,
                          queRaw,
                          capText,
                          capRaw,
                          null,
                          infoTxt,
                          null,
                          null,
                          mutiOptFields
                        );
                      else {
                        setAlertMsg({
                          title: "Alert",
                          msg: "Nothing is added.",
                        });
                      }
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    variant="text"
                    color="primary"
                    className={classes.outlinedButtonStyle}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item lg={8} md={8} xl={8}>
            <Card style={{ backgroundColor: "#E3F2FD" }}>
              <Box
                mt={6}
                mb={1.5}
                ml={10}
                mr={10}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Box style={{ display: "flex", flexDirection: "row" }}>
                    {infoIcon && infoTxt ? (
                      <StyledTooltip title={infoTxt}>
                        <img
                          style={{
                            paddingBottom: 3,
                            paddingRight: 5,
                            height: 24,
                            paddingTop: singleOpt && 8,
                          }}
                          src={infoImg}
                        />
                      </StyledTooltip>
                    ) : infoIcon && !infoTxt ? (
                      <img
                        style={{
                          paddingBottom: 3,
                          paddingRight: 5,
                          height: 24,
                          paddingTop: singleOpt && 8,
                        }}
                        src={infoImg}
                      />
                    ) : (
                      ""
                    )}
                  </Box>
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // paddingLeft: 5,
                    }}
                  >
                    <div
                      style={{
                        wordBreak: "break-word",
                      }}
                    >
                      {singleOpt && manAnswer && (
                        <>
                          <span style={{ color: "#E53935", verticalAlign: "sub" }}>
                            {" "}
                            *
                          </span>
                          <Checkbox />
                        </>
                      )}
                      {singleOpt && !manAnswer && <Checkbox />}
                      {queText ? queText : ""}
                    </div>
                  </Typography>
                </Box>

                <Typography
                  variant="h3"
                  style={{
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 3,
                    paddingBottom: 5,
                    paddingTop: 20,
                  }}
                >
                  <div
                    style={{
                      wordBreak: "break-word",
                    }}
                  >
                    {capText ? capText : ""}
                  </div>
                </Typography>

                <Box pb={0.25} style={{ display: "flex", flexDirection: "row" }}>
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: 5,
                      // paddingRight: 5,
                      fontSize: 14,
                    }}
                  >
                    {multipleOpt && manAnswer ? (
                      <div>
                        Required <span style={{ color: "#E53935" }}> *</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Box>

                {mutiOptFields.map((element, index) => (
                  <FormControlLabel control={<Checkbox />} label={element.textVal} />
                ))}
              </Box>
            </Card>
          </Grid>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              type={alertMsg.type}
              contentMsg={alertMsg.msg}
              closeDialog={() => setAlertMsg([])}
              cancelSaveAction={() => {
                setAlertMsg([]);
                handleClose();
              }}
            />
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
